import { useEffect, useMemo, useState } from "react"

/**
 * Hook to control the single open behaviour
 * @param {useSingleOpenArgs} args
 *
 * @returns {singleOpenReturn}
 */
export function useSingleOpen({ enforceSingleOpen, items }) {
  const initialOpenMap = useMemo(() => {
    if (!enforceSingleOpen) return []
    return items.map(({ initialOpen }) => Boolean(initialOpen))
  }, [items, enforceSingleOpen])

  const [openMap, setOpenMap] = useState(initialOpenMap)

  useEffect(() => {
    if (!enforceSingleOpen) {
      return
    }

    // the last oppened item is the one to be singled out as open
    for (let i = items.length - 1; i > -1; i--) {
      if (items[i].initialOpen) {
        setOpenMap({ [i]: true })

        break
      }
    }
  }, [items, enforceSingleOpen])

  function getItemOpenProps(index) {
    const openProps = {}

    if (enforceSingleOpen) {
      openProps.open = Boolean(openMap[index])
      openProps.isControlled = true
      openProps.onToogle = (isOpen) => {
        setOpenMap({ [index]: isOpen })
      }
    } else {
      openProps.initialOpen = items[index].initialOpen
    }

    return openProps
  }

  return { openMap, setOpenMap, getItemOpenProps }
}

/**
 *
 * @typedef {Object} useSingleOpenArgs
 *
 * @property {boolean[]} openMap an arrayLike object with true if it is open
 * @property {function} setOpenMap  setter for open map
 * @property {function} getItemOpenProps get the appropriate dropdown item props regarding open state
 *
 */

/**
 *
 * @typedef {Object} singleOpenReturn
 *
 * @property {Object[]} items array of dropdown items
 * @property {boolean} enforceSingleOpen if false won't use internal state
 */
